module.exports = __webpack_public_path__ + "static/media/project-launch.8ac8fc28.svg";